export default "__VITE_ASSET__5fef075e__"